import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, Button, Table, Text, Tooltip } from "@mantine/core";
import { ArchiveOutlined, RestoreOutlined } from "@mui/icons-material";
import { IconButton, SvgIcon } from "@mui/material";
import { getRelativeTimeFromDate } from "../../utils/Date.utils";
import { createShortAddressString } from "../../utils/String.utils";
import { ContactInfo } from "../../shared/ContactInfo";
export const PriorityReferralRow = ({ priorityReferral, movePriorityReferralToPriorityEntry, archiveRestorePriorityReferral, modalHandlers }) => {
    const caregiverName = `${priorityReferral?.caregiver?.lastName}, ${priorityReferral?.caregiver?.firstName}`;
    const patientName = `${priorityReferral?.patient?.lastName}, ${priorityReferral?.patient?.firstName}`;
    const therapyCategoryName = priorityReferral?.therapyCategory?.name;
    const location = priorityReferral?.patient?.postalCodeInfo
        ? createShortAddressString(priorityReferral?.patient?.postalCodeInfo)
        : "-";
    const openPatientProfileDrawer = () => {
        modalHandlers?.patientProfileDrawerOpen(priorityReferral?.patient?.patientId ?? "");
    };
    return (_jsxs(Table.Tr, { style: { cursor: "pointer" }, onClick: openPatientProfileDrawer, onDoubleClick: (event) => {
            event.stopPropagation();
            event.preventDefault();
        }, children: [_jsx(Table.Td, { style: { paddingLeft: "0.5rem" }, children: _jsx(Text, { variant: "body", size: "xs", truncate: "end", children: caregiverName }) }), _jsx(Table.Td, { children: _jsx(ContactInfo, { email: priorityReferral?.caregiver?.email ?? "", phoneNumber: priorityReferral?.caregiver?.phoneNumber ?? "" }) }), _jsx(Table.Td, { children: _jsx(Text, { variant: "body", size: "xs", truncate: "end", children: patientName }) }), _jsx(Table.Td, { children: therapyCategoryName && (_jsx(Badge, { size: "xs", color: "var(--mantine-color-secondary-5)", children: therapyCategoryName }, therapyCategoryName)) }), _jsx(Table.Td, { children: _jsx(Text, { variant: "meta", truncate: "end", children: location }) }), _jsx(Table.Td, { children: priorityReferral?.createdAt
                    ? getRelativeTimeFromDate(priorityReferral?.createdAt)
                    : "-" }), _jsx(Table.Td, { children: _jsxs("div", { style: {
                        display: "flex",
                        gap: "0.5rem",
                        alignItems: "center",
                        justifyContent: "flex-end"
                    }, children: [!priorityReferral?.archivedAt && (_jsx(Button, { variant: "outline", style: { flexShrink: 0 }, styles: {
                                root: {
                                    color: "var(--mantine-color-secondary-5)",
                                    borderColor: "var(--mantine-color-secondary-5)"
                                }
                            }, onClick: (e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                movePriorityReferralToPriorityEntry(priorityReferral?.priorityReferralId ?? "");
                            }, children: "Add to Pipeline" })), _jsx(Tooltip, { label: priorityReferral?.archivedAt
                                ? "Restore Lead"
                                : "Archive Lead", position: "bottom-start", openDelay: 750, transitionProps: {
                                transition: "slide-up",
                                duration: 150
                            }, children: _jsx(IconButton, { style: {
                                    color: priorityReferral?.archivedAt
                                        ? "var(--mantine-color-primary-9)"
                                        : "var(--mantine-color-red-5)"
                                }, onClick: (e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    archiveRestorePriorityReferral(priorityReferral?.priorityReferralId ?? "");
                                }, children: _jsx(SvgIcon, { component: priorityReferral?.archivedAt
                                        ? RestoreOutlined
                                        : ArchiveOutlined, style: { fontSize: "1.2rem" } }) }) })] }) })] }));
};
